export default __webpack_public_path__ + "static/media/cyberoffice-schedule.4eec95af.gif";